import clsx from 'clsx'
import React, { useCallback, useRef, useState } from 'react'

import { Button } from '@Components/Button'
import { useClub } from '@Domains/Club/Hook'
import { useTranslation } from '@Globals/Translations'
import { EmailValidationV2 } from '@Shared/Components/Forms/Validations/EmailValidation'
import { NotEmptyValidationV2 } from '@Shared/Components/Forms/Validations/NotEmptyValidation'
import { PasswordValidation } from '@Shared/Components/Forms/Validations/PasswordValidation'
import { TextInput, useTextInputActionRef } from '@Shared/Components/Inputs/TextInput/TextInput'

import styles from './styles.module.scss'

export const ClubCreateAccountOnlyPassword = () => {
  const { defaultEmail, setModalState } = useClub()
  const { t } = useTranslation()
  const emailActionRef = useTextInputActionRef()
  const [email, setEmail] = useState(defaultEmail || '')
  const passwordActionRef = useTextInputActionRef()
  const [password, setPassword] = useState('')
  const passwordRef = useRef(password)
  const passwordRepeatActionRef = useTextInputActionRef()
  const [passwordRepeat, setPasswordRepeat] = useState('')

  // TODO: SEND SIGNUP REQUEST HERE
  const onSignUp = useCallback(() => {
    setModalState('VERIFY_EMAIL')
  }, [setModalState])

  return (
    <form onSubmit={(e) => {
      e.preventDefault()
      e.stopPropagation()
      emailActionRef.current?.touch()
      const isEmailValid = emailActionRef.current?.validate()
      passwordActionRef.current?.touch()
      const isPasswordValid = passwordActionRef.current?.validate()
      passwordRepeatActionRef.current?.touch()
      const isPasswordRepeatValid = passwordRepeatActionRef.current?.validate()
      if (isEmailValid && isPasswordValid && isPasswordRepeatValid) {
        onSignUp()
      }
    }}
    >
      <p className={styles.smallHeader}>{t('common:TRENDHIMCLUB_CREATE_A_NEW_PASSWORD')}</p>
      <p>{t('common:TRENDHIMCLUB_ENTER_EMAIL_NEW_PASSWORD')}</p>
      <p className={styles.smallLabel}>{t('common:EMAIL_ADDRESS')}</p>
      <TextInput
        actionRef={emailActionRef}
        className={styles.formElementGab}
        id="ClubModal_Signup_Email"
        label={t('common:EMAIL_ADDRESS')}
        onChange={value => setEmail(value)}
        validations={[EmailValidationV2]}
        value={email}
      />
      <p className={styles.smallLabel}>{t('common:TRENDHIMCLUB_CREATE_PASSWORD')}</p>
      <TextInput
        className={styles.formElementGab}
        id="ClubModal_Signup_Password"
        label={t('common:PASSWORD')}
        onChange={(value) => {
          passwordRef.current = value
          setPassword(value)
        }}
        type="password"
        validations={[NotEmptyValidationV2, PasswordValidation]}
        value={password}
      />

      <TextInput
        className={styles.formElementGab}
        id="ClubModal_Signup_Password_Repeat"
        label={t('common:REPEAT_PASSWORD')}
        onChange={value => setPasswordRepeat(value)}
        type="password"
        validations={[
          NotEmptyValidationV2, PasswordValidation, v => ({
            errorMessage: 'common:THE_2_PASSWORD_ARE_NOT_SAME',
            success: v === passwordRef.current,
          }),
        ]}
        value={passwordRepeat}
      />
      <Button
        className={clsx(styles.nextButton, styles.formElementGab)}
        color="black"
        style={{ margin: '0' }}
        type="submit"
      >
        {t('common:TRENDHIMCLUB_CREATE_LABEL')}
      </Button>
    </form>
  )
}

